module.exports = __webpack_public_path__ + "img/6.0a4bed9a.jpg";